import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import Home from '@/views/Home.vue';
import Dashboard from '@/views/Dashboard/DashboardView.vue';
import Einstellungen from '@/views/Dashboard/EinstellungenView.vue';

import Personaldaten from '@/views/Personaldaten/PersonaldatenView.vue';
import DetailsPersonaldaten from '@/views/Personaldaten/DetailsPersonaldatenView.vue';

import Druckvorlagen from '@/views/Druckvorlagen/DruckvorlagenView.vue';

import Vertraege from '@/views/Vertraege/VertraegeView.vue';
import EditVertrag from '@/views/Vertraege/EditVertragView.vue';
import DetailsVertrag from '@/views/Vertraege/DetailsVertragView.vue';

import EditVertragDokument from '@/views/Vertraege/EditVertragDokumentView.vue';

import Vertragspartner from '@/views/Vertragspartner/VertragspartnerView.vue';
import EditVertragspartner from '@/views/Vertragspartner/EditVertragspartnerView.vue';
import DetailsVertragspartner from '@/views/Vertragspartner/DetailsVertragspartnerView.vue';

import Signaturen from '@/views/Signaturen/SignaturenView.vue';
import EditSignatur from '@/views/Signaturen/EditSignaturView.vue';
import DetailsSignatur from '@/views/Signaturen/DetailsSignaturView.vue';

import Vorlagen from '@/views/Vorlagen/VorlagenView.vue';
import EditVorlage from '@/views/Vorlagen/EditVorlageView.vue';
import DetailsVorlage from '@/views/Vorlagen/DetailsVorlageView.vue';

import Textbausteine from '@/views/Vorlagen/TextbausteineView.vue';
import EditTextbaustein from '@/views/Vorlagen/EditTextbausteinView.vue';

import Textvariablen from '@/views/Textvariablen/TextvariablenView.vue';

const routes: Array<RouteRecordRaw> = [
  //#region Dashboard / Home
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
  },

  {
    path: '/start',
    name: 'Home',
    component: Home,
  },

  {
    path: '/settings',
    name: 'Einstellungen',
    component: Einstellungen,
  },
  //#endregion

  //#region Personaldaten
  {
    path: '/mitarbeiter',
    name: 'Personaldaten',
    component: Personaldaten,
  },
  {
    path: '/mitarbeiter/details/:guid',
    name: 'DetailsPersonaldaten',
    component: DetailsPersonaldaten,
    props: true,
  },
  //#endregion

  //#region Vertraege
  {
    path: '/vertraege',
    name: 'Vertraege',
    component: Vertraege,
  },
  {
    path: '/vertrag/edit',
    name: 'EditVertrag',
    component: EditVertrag,
    props: (route) => ({ vertragid: route.query.vertragid, guid: route.query.guid }),
  },
  {
    path: '/vertrag/details',
    name: 'DetailsVertrag',
    component: DetailsVertrag,
    props: (route) => ({ vertragid: route.query.vertragid, guid: route.query.guid }),
  },

  {
    path: '/vertrag/dokument/edit',
    name: 'EditVertragDokument',
    component: EditVertragDokument,
    props: (route) => ({ vertragid: route.query.vertragid, dokumentid: route.query.dokumentid }),
  },
  //#endregion

  //#region Signaturen
  {
    path: '/signaturen',
    name: 'Signaturen',
    component: Signaturen,
  },
  {
    path: '/signaturen/edit',
    name: 'EditSignatur',
    component: EditSignatur,
    props: (route) => ({ signaturid: route.query.signaturid }),
  },
  {
    path: '/signaturen/details',
    name: 'DetailsSignatur',
    component: DetailsSignatur,
    props: (route) => ({ signaturid: route.query.signaturid }),
  },
  //#endregion

  //#region Vertragspartner
  {
    path: '/vertragspartner',
    name: 'Vertragspartner',
    component: Vertragspartner,
  },
  {
    path: '/vertragspartner/edit',
    name: 'EditVertragspartner',
    component: EditVertragspartner,
    props: (route) => ({ vertragspartnerid: route.query.vertragspartnerid }),
  },
  {
    path: '/vertragspartner/details',
    name: 'DetailsVertragspartner',
    component: DetailsVertragspartner,
    props: (route) => ({ vertragspartnerid: route.query.vertragspartnerid }),
  },
  //#endregion

  //#region Druckvorlagen
  {
    path: '/druckvorlagen',
    name: 'Druckvorlagen',
    component: Druckvorlagen,
  },
  //#endregion

  //#region Vorlagen
  {
    path: '/vorlagen',
    name: 'Vorlagen',
    component: Vorlagen,
  },
  {
    path: '/vorlagen/edit',
    name: 'EditVorlage',
    component: EditVorlage,
    props: (route) => ({ vorlageid: route.query.vorlageid }),
  },
  {
    path: '/vorlagen/details/:vorlageid',
    name: 'DetailsVorlage',
    component: DetailsVorlage,
    props: true,
  },
  //#endregion

  //#region Textbausteine
  {
    path: '/textbausteine',
    name: 'Textbausteine',
    component: Textbausteine,
  },
  {
    path: '/textbaustein/edit',
    name: 'EditTextbaustein',
    component: EditTextbaustein,
    props: (route) => ({ textbausteinid: route.query.textbausteinid }),
  },
  //#endregion

  //#region Textvariablen
  {
    path: '/textvariablen',
    name: 'Textvariablen',
    component: Textvariablen,
  },
  //#endregion

  //#region Login & Logout
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  //#endregion

  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

import { useStore } from '@/store';

router.beforeEach((to, from, next) => {
  const store = useStore();
  let availablePages = store.getters.publicPages;

  const authUser = store.getters.authUser;
  if (authUser != null && !authUser.isAdmin) {
    availablePages = store.getters.benutzerPages;
  } else if (authUser != null && authUser.isAdmin) {
    availablePages = store.getters.adminPages;
  }

  if (availablePages.includes(to.name as string)) {
    // console.log('available');
    next();
  } else if (from.name != null) {
    // console.log('return to ' + (from.name as string));
    next(from);
  } else {
    // console.log('return to Home');
    next({ name: 'Login' });
  }
});

export default router;
